



































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import StepMixin from '@mixin/step';
import StoreFileMixin from '@mixin/storeFile';
import ErrorResponseMixin from '@mixin/errorResponse';
import axios from 'axios';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            post: {
                file: null,
                owner: 'organisation',
                type: 'statuten',
            },
        };
    },

    mixins: [
        StepMixin,
        StoreFileMixin,
        ErrorResponseMixin
    ],

    created() {
        this.post.id = this.current.organisation_id;
        this.downloadFile(this.post);
    },

    methods: {

        async onNext() {
            if (!this.post.file)
                return true;

            const data = {...this.post};

            data.file = this.post.file[0];

            return this.$store.dispatch('organisation/uploadFile', data).then(response => {
                if (response instanceof Error) {
                    this.errorData = this.getErrorMessage(response);
                    return false;
                }
                return true;
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Statuten extends Vue {}

